import { useQuery } from '@tanstack/react-query';
import { get } from '../../../lib/api';

const serializeAudiences = audiences =>
  audiences.map(audience => ({
    label: audience.name,
    className: 'audience-option',
    value: audience.id,
    color: audience.color,
    population: (audience.population_segments || []).map(({ id, name }) => ({
      value: id,
      label: name,
    })),
    segmentGroups: audience.segment_groups || [],
    audienceSize: audience.audience_size,
  }));

const serializeRibbonTags = tags =>
  tags.map(tag => ({
    label: tag.name,
    className: 'ribbon-tag-option',
    value: tag.id,
    color: tag.color,
  }));

export const useGetBoardSettings = () => {
  const { data = {} } = useQuery(['boardSettings'], () =>
    get('/api/v1/board_settings'),
  );

  return {
    topics: data.ribbonTags ? serializeRibbonTags(data.ribbonTags) : [],
    audiences: data.audiences ? serializeAudiences(data.audiences) : [],
    billingInfo: data.billingInfo || {},
  };
};
